import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { styled } from '@linaria/react';
import { Icon } from '@vio/atlas/Icon';
import { DisplayType, FilterDisplayContainer } from 'components/FilterDisplayContainer/FilterDisplayContainer';
import { useFiltersForm } from 'hooks/useFiltersForm';
import { filterMessages } from '../../Filters/filterMessages';
import { getAllFilterKeys } from '../../Filters/utils';
import { FiltersOverlayContent } from '../FiltersOverlayContent/FiltersOverlayContent';
const ScrollWrapper = /*#__PURE__*/styled('div')({
  name: "ScrollWrapper",
  class: "sg88sa3",
  propsAsIs: false
});
const allFilterKeys = getAllFilterKeys();
const elementName = 'allFilters';

/**
 * Overlay which displays all filters
 */
export const AllFiltersOverlay = () => {
  const {
    formatMessage
  } = useIntl();
  const {
    getAppliedFiltersCount,
    getFilters,
    getAppliedFilters,
    toggleFilters,
    toggleMultiFilter,
    setMultiFilters,
    removeMultiFilters,
    submitFilters,
    clearFilters,
    resetFilters,
    trackFilterClick,
    getFiltersCount
  } = useFiltersForm(allFilterKeys, elementName);
  const count = getAppliedFiltersCount();
  const handleApply = useCallback(() => {
    submitFilters();
  }, [submitFilters]);
  return <FilterDisplayContainer dataId="allFiltersFilter" type={DisplayType.Overlay} label={formatMessage(filterMessages.filters)} title={formatMessage(filterMessages.allFilters)} isActive={false} icon={<Icon name="SettingsSliders" />} showArrow={false} count={count} onClear={clearFilters} onApply={handleApply} onClose={resetFilters} onPillClick={trackFilterClick} pillVariant="link" paddingBottom="s000">
      <ScrollWrapper>
        <FiltersOverlayContent getFilters={getFilters} getAppliedFilters={getAppliedFilters} toggleFilters={toggleFilters} toggleMultiFilter={toggleMultiFilter} getFiltersCount={getFiltersCount} setMultiFilters={setMultiFilters} removeMultiFilters={removeMultiFilters} />
      </ScrollWrapper>
    </FilterDisplayContainer>;
};

require("./FiltersOverlayDesktop.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./FiltersOverlayDesktop.tsx");